import React from 'react';
import { Stack } from '@cad-arc';
import { LetterIcon } from '../../../event-panel/tabs/event-details/components/helpers/utility-components';
import { TabSection } from './tab-section';

export function DispatchSection({
    dispatcher,
    callTaker,
}: {
    dispatcher?: string;
    callTaker?: string;
}): React.ReactElement {
    return (
        <TabSection>
            <Stack spacing={3}>
                {!!(dispatcher || callTaker) && (
                    <Stack>
                        {dispatcher ? <LetterIcon type="dispatcher" label={dispatcher} /> : null}
                        {callTaker ? <LetterIcon type="callTaker" label={callTaker} /> : null}
                    </Stack>
                )}
            </Stack>
        </TabSection>
    );
}
